import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ra-info',
  templateUrl: './ra-info.component.html',
  styleUrls: ['./ra-info.component.scss']
})
export class RaInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
